import InsuranceLayout from "./InsuranceLayout";
import InsuranceListPage from "./pages/InsuranceListPage";
import InsuranceCreatePage from "./pages/InsuranceCreatePage";
import InsuranceDetailPage from "./pages/InsuranceDetailPage";

export const insuranceRoutes = {
  path: "insurances",
  component: InsuranceLayout,
  children: [
    {
      name: "InsuranceCreatePage",
      component: InsuranceCreatePage,
      path: "create"
    },
    {
      name: "InsuranceDetailPage",
      component: InsuranceDetailPage,
      path: ":id"
    },
    {
      name: "InsuranceListPage",
      component: InsuranceListPage,
      path: ""
    }
  ]
};
